angular.module('env.i18n', [
    'env.i18n.appLocale',
    'env.i18n.serverLocalization',
    'env.i18n.serverLocalizationFilter',
    'env.i18n.uiLocalization',
    'env.i18n.angularLocalization',
    'env.i18n.kendoLocalization',
    'env.i18n.kendoMessages',

    'env.i18n.localeName'
])

;